
import Home from "./page/Home";


export default  [
    {path: '/', component: Home }
]